import {connect} from 'react-redux';

import {InstantlyFormItem} from '../libs/ui/src';

import {headerModalActions} from '../redux/headerModal';
import {instantlyActions} from '../redux/instantly';

function mapState(state: any, ownProps: any) {
  return {
    isLoading: state.instantly.isLoading,
    isTokenVerified: state.instantly.isTokenVerified,
    error: state.instantly.error,
    errors: ownProps.errors,
    touched: ownProps.touched,
    values: ownProps.values,
    campaigns: state.instantly.campaigns,
    onChangeCampaigns: ownProps.onChangeCampaigns,
    tags: ownProps.tags,
    onChangeTags: ownProps.onChangeTags,
    showTags: ownProps.showTags,
  };
}

const actionCreators = {
  getCampaigns: instantlyActions.getCampaigns,
  openSettings: () => headerModalActions.setHeaderModal('instantly'),
};

export const InstantlyFormItemContainer = connect(mapState, actionCreators)(InstantlyFormItem);
